import * as swcHelpers from '@swc/helpers';
import { LineItemModels } from '@grandvisionhq/lib-visuals';
import { isNil } from '@grandvisionhq/utils';
import '../utils/get-payment-status-label.js';
import { getPrices } from '../utils/get-prices.js';
import '@grandvisionhq/graphql';
import { mapBundleChildLineItems } from '../utils/map-bundle-child-line-items.js';
import { toBaseLineItem } from './base-line-item.js';

function toLens(lens) {
    const { pupillaryDistance , prism , power , cylinder , axis , addition  } = lens;
    return swcHelpers.objectSpread({}, !isNil(pupillaryDistance) ? {
        pupillaryDistance
    } : null, !isNil(prism) ? {
        prism
    } : null, !isNil(power) ? {
        power
    } : null, !isNil(cylinder) ? {
        cylinder
    } : null, !isNil(axis) ? {
        axis
    } : null, !isNil(addition) ? {
        addition
    } : null);
}
function getPrescription(lineItem) {
    const { prescription  } = lineItem;
    switch(prescription === null || prescription === void 0 ? void 0 : prescription.__typename){
        case 'AddedGlassesPrescription':
            return {
                type: LineItemModels.PrescriptionType.NEW_PRESCRIPTION,
                leftEye: toLens(prescription.leftLens),
                rightEye: toLens(prescription.rightLens)
            };
        case 'FilePrescription':
            return {
                type: LineItemModels.PrescriptionType.PRESCRIPTION_FILE,
                prescriptionFile: prescription.prescriptionFileName,
                pupillaryDistanceFile: prescription.pupillaryDistanceFileName
            };
        case 'EmailPrescription':
            return {
                type: LineItemModels.PrescriptionType.EMAIL_PRESCRIPTION
            };
        case 'OCRPrescription':
            return {
                type: LineItemModels.PrescriptionType.OCR_PRESCRIPTION
            };
        default:
            return {
                type: LineItemModels.PrescriptionType.EXISTING_CUSTOMER
            };
    }
}
const toGlassesBundleOrderLineItem = (lineItem, intl, options = {})=>{
    const { originalPrice , discountPrice  } = getPrices(lineItem);
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'GLASSES_BUNDLE',
        productType: 'prescription-glasses',
        prescription: getPrescription(lineItem),
        // originalPrice is the price we show as TOTAL PRICE for the entire bundle, including child line items
        originalPrice: originalPrice || 0,
        // lineItemDiscountedPrice is the price with the discount applied which we show next to the TOTAL PRICE for the entire bundle, including child line items
        discountPrice,
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};

export { toGlassesBundleOrderLineItem };
//# sourceMappingURL=glasses-bundle-line-item.js.map
